import type { NextPage } from 'next'
import Meta from '@g4g/ui/src/internal/head/Meta'
import ShoppingCartPageLayout from '../../components/layout/ShoppingCartPageLayout'
import CheckoutPaymentCard from '../../components/checkout/payment/CheckoutPaymentCard'
import CheckoutItemsSummary from '../../components/checkout/CheckoutItemsSummary'
import ClientOnly from '@g4g/ui/src/utility/ClientOnly'
import useGtmVisit from '../../utils/gtm/useGtmVisit'

const Checkout: NextPage = () => {
  useGtmVisit('begin_checkout')
  return (
    <>
      <Meta
        app="shop"
        title="Checkout | Mobile Minigames Shop"
        canonical="https://shop.mobileminigames.com/checkout"
        socialMediaImage={
          (process.env.NEXT_PUBLIC_SHOP_APP_URL ?? 'https://shop.mobileminigames.com') +
          '/shop_app_social.jpg'
        }
        socialMediaImageAlt="Mobile Minigames Shop"
      />
      <ClientOnly>
        <ShoppingCartPageLayout path="checkout" title="Checkout" side={<CheckoutPaymentCard />}>
          <CheckoutItemsSummary />
        </ShoppingCartPageLayout>
      </ClientOnly>
    </>
  )
}

export default Checkout
